import Vue from 'vue'
import {Pagination,Radio,DatePicker,Cascader,Input,Upload,Button} from 'element-ui';
// import BaiduMap from 'vue-baidu-map'
import 'element-ui/lib/theme-chalk/index.css';
import jquery from "jquery";
import router from "./router/router.js";
import api from './http.js'
// import bootstrap from "bootstrap";
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/flexslider.css';
import './assets/css/liMarquee.css';
import './assets/css/owl.carousel.css';
import './assets/css/common.css';
import './assets/css/media-1.css';
import App from './App.vue'
const icoURL = 'https://www.mtdz.com/'

Vue.prototype.icoURL = icoURL
Vue.config.productionTip = false
Vue.prototype.axios = api
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Cascader)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Button)

 
// Vue.use(BaiduMap, {
//   ak: 'cLD5R0t9oEr9pThUe9YWCYsf25w9vGXF' // ak 是在百度地图开发者平台申请的密钥
// })

//引入
import hHeader from './components/hHeader'
import foot from './components/foot'
import hmenu from './components/hmenu'


//注册为全局组件
Vue.component('hHeader',hHeader)
Vue.component('foot',foot)
Vue.component('hmenu',hmenu)









new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
